<template>
  <div>
    <app-component-empty-state v-if="loading == false && desserts.length == 0" 
      :title="'Ops! Não existem Metas cadastradas'" 
      :text="'Clique em “Nova Meta” para começar a cadastrar uma Meta no sistema.'">
    </app-component-empty-state>
    <v-card v-else>
        <v-col cols="12">
            <span class="grey--text text--darken-4 subtitle-1">Metas cadastrados</span>
        </v-col> 
        <v-data-table
          :loading="loading" loading-text="Carregando..."
          :headers="headers"
          :items="desserts"
          :search="search"
        >
          <template v-slot:item.value="{ item }">
            <span>{{formatterDecimal.format(item.value)}}</span>
          </template>
          <template v-slot:item.created_at="{ item }">
            <span>{{moment(item.created_at).format('DD/MM/YYYY')}}</span>
          </template>
          <template v-slot:item.actions="{ item }">
            <app-dashboard-meta-edit :meta="item" v-on:notification="notification = $event" @getData="getReportFinancialMeta"></app-dashboard-meta-edit>
          </template>
        </v-data-table>
    </v-card>
  </div>
</template>

<script>
import DashboardFinancialMetaEdit from './DashboardFinancialMetaEdit.vue'
import moment from 'moment'
import EmptyState from '../components/EmptyState.vue'

export default {
    components: {
        'app-dashboard-meta-edit': DashboardFinancialMetaEdit,
        'app-component-empty-state': EmptyState
    },
    props: {
      loadData: {
          type: Boolean,
          required: true,
          default: null
      },
      channel: {
          type: Number,
          required: true,
          default: null
      }
    },
    watch: {
      loadData: function () {
        this.getReportFinancialMeta();
        this.$emit('loadFalse')
      },
      notification: function() {
        this.$emit('notification', this.notification);
      }
    },
    created() {
      this.moment.locale('pt-BR');
      this.getReportFinancialMeta();
    },
    data: () => ({
        search: '',
        moment: moment,
        loading: false,
        formatterDecimal: new Intl.NumberFormat('pt-BR', {currency: 'BRL'}),
        headers: [
          { text: 'Período', sortable: true, value: 'date' },
          { text: 'Valor', value: 'value', sortable: false },
          { text: 'Registrado em', value: 'created_at', sortable: false },
          { text: 'Adicionado por', value: 'created_by', sortable: false },
          { text: 'Ações', align: 'center', value: 'actions', sortable: false, filterable: false },
        ],
        desserts: [],
        notification: {
          active: false,
          description: '',
          type: '',
          closeText: ''
        }
    }),
    methods: {
        getReportFinancialMeta() {
          this.$http.get( '/channel/'+ this.channel +'/goal' )
          .then( ( res ) => {
            this.desserts = res.data;
          } ).catch( () => {
            this.notification = {
              active: true,
              description: 'Houve um erro na solicitação.',
              type: 'error',
              closeText: 'Fechar'
            },
            this.$emit( 'notification', this.notification );
          } ).finally( () => {
            this.loading = false;
          } );
        }
    }
}
</script>

<style scoped>
  .d-content {
    display: contents !important;
  }
  .table-min-height {
    min-height: 60vh;
  }
</style>